/*项目的全局配置文件
  关卡配置
  地图配置
  游戏规则配置
  画布配置
*/
export const CONFIG = Object.freeze({
  mapWidth: 51,
  mapHeight: 31,

  levelCount: 100,
  levelOrder: Array.from({ length: 100 }, (_, index) => index + 1),
  beginLevel: 1,
  extraLevelStart: 15,

  innerSideLength: 7,
  innerInterval: 1,
  sideLength: 9,
  // 顶部 HUD 只缩小高度，不改变信息排版；地图和挡板整体同步上移。
  stateBarHeight: 112,
  windowBottomMargin: 187,

  boardHalfWidth: 55,  //挡板半长度
  boardHalfThickness: 5,  //挡板半厚度
  boardYDistance: 181,
  boardBallDistance: 16,

  ballRadius: 6, //小球半径
  ballMaxCount: 1024,
  ballLives: 3,
  ballSpeed: 0.7,
  // 所有关卡开局都只发射一个球；多球只能由玩家主动使用技能获得。
  extraLevelInitialBallCount: 1,

  processRepeat: 3,
 //道具掉落速度与概率
  propMaxCount: 1024,
  propDropSpeed: 0.20,
  propProbability3x: 0,
  propProbabilityShoot3: 0,
  propProbabilityHeart: 0,
  extraLevelMultiBallDropMultiplier: 1.5,

  // 可主动使用的道具背包。后续接入后端时可以由服务端下发这些值。
  inventoryItemMaxCount: 15,
  inventoryInitialTriple: 2,
  inventoryInitialShootThree: 2,
  levelClearRewardTriple: 1,
  levelClearRewardShootThree: 1,

  // 体力系统。每开始一局扣除体力，通关后返还；未满时按固定间隔自然恢复。
  energyMax: 30,
  energyInitial: 30,
  energyCostPerRound: 5,
  // 多长时间进行一次自然恢复
energyRecoveryIntervalMs: 5 * 60 * 1000,

// 每次自然恢复多少点体力
energyRecoveryAmount: 5,
  levelClearEnergyRefund: 5
});

export const CANVAS = Object.freeze({
  width: CONFIG.mapWidth * CONFIG.sideLength,
  height:
    CONFIG.stateBarHeight +
    CONFIG.mapHeight * CONFIG.sideLength +
    CONFIG.windowBottomMargin
});

export const COLORS = Object.freeze({
  "#": "rgb(163,163,162)",
  R: "rgb(214,63,37)",
  E: "rgb(242,66,41)",
  Y: "rgb(228,174,31)",
  G: "rgb(15,216,15)",
  C: "rgb(39,253,251)",
  B: "rgb(68,112,202)",
  W: "rgb(234,234,234)",
  P: "rgb(70,245,110)",
  p: "rgb(15,160,65)"
});



